import React from "react";
import ReactDOM from "react-dom";
import "./fonts.css";
import "./tailwind.css";
import reportWebVitals from "./reportWebVitals";
import { enableMapSet } from "immer";
import { firebaseConfig, APP_URLS as APP_URLS_DEV } from "./constant";
import { APP_URLS as APP_URLS_PROD } from "./constant/production";
import Router from "./routes";
enableMapSet();

const hostname = window.location.hostname;
const projectId = firebaseConfig.projectId;
if (process.env.NODE_ENV === "production" && hostname !== "localhost") {
  let appURLs = APP_URLS_PROD;
  if (projectId === "mortgage-rec-engine-prod") {
    appURLs = APP_URLS_PROD;
  } else if (projectId === "mortgage-rec-engine-dev") {
    appURLs = APP_URLS_DEV;
  }

  if (!appURLs.some((url) => url.includes(hostname))) {
    window.location.href = appURLs[0];
  }
}

ReactDOM.render(
  <React.StrictMode>
    <Router />
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
